import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";

import { Grid } from "@mui/material";
import React from "react";

const RelationStatsSkeleton = () => {
	return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "30px" }}>
				<Skeleton variant="rectangular" width={255.7} height={36.7} />
				<Skeleton variant="rectangular" width={256.25} height={35.8} />
				<Skeleton variant="rectangular" width={272} height={36.7} />
				<Skeleton variant="rectangular" width={70} height={35.8} />
				<Skeleton variant="rectangular" width={157} height={35.8} />
			</Box>
            <Grid container spacing={5}>
				<Grid size={3}>
					<Skeleton variant="rectangular" height={300} />
				</Grid>
				<Grid size={3}>
					<Skeleton variant="rectangular" height={300} />
				</Grid>
				<Grid size={3}>
					<Skeleton variant="rectangular" height={300} />
				</Grid>
				<Grid size={3}>
					<Grid container spacing={4}>
						<Grid size={12}>
							<Skeleton variant="rectangular" height={300} />
						</Grid>
						<Grid size={12}>
							<Skeleton variant="rectangular" height={300} />
						</Grid>
					</Grid>
				</Grid>
			</Grid>
        </Box>
    );
};

export default RelationStatsSkeleton;
